// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Action from 'core/fsmpack/statemachine/actions/Action';
import Material from 'core/renderer/Material';
import ShaderLib from 'core/renderer/shaders/ShaderLib';
import ParticleLib from 'core/particles/ParticleLib';
import ParticleSystemUtils from 'core/util/ParticleSystemUtils';

// spell-checker: words Pickable Mipmaps

/**
 * @autodoc apply FsmAction
 */
class SmokeAction extends Action {

  constructor(options) {
    super(...arguments); // also support (id, settings) parameters used with FSM
    this.smokeEntity = null;
  }

  enter(fsm) {
    const entity = fsm.getOwnerEntity();
    if (this.smokeEntity && entity.transformComponent.children.indexOf(this.smokeEntity.transformComponent) !== -1) {
      return;
    }

    const sumerianRunner = entity._world.sumerianRunner;

    if (!SmokeAction.material) {
      SmokeAction.material = new Material(ShaderLib.particles);
      const texture = ParticleSystemUtils.createFlareTexture();
      texture.generateMipmaps = true;
      SmokeAction.material.setTexture('DIFFUSE_MAP', texture);
      SmokeAction.material.blendState.blending = 'TransparencyBlending';
      SmokeAction.material.cullState.enabled = false;
      SmokeAction.material.depthState.write = false;
      SmokeAction.material.renderQueue = 2001;
    }

    const entityScale = entity.transformComponent.getWorldScale();
    const scale = (entityScale.x + entityScale.y + entityScale.z) / 3;
    this.smokeEntity = ParticleSystemUtils.createParticleSystemEntity(
      sumerianRunner.world,
      ParticleLib.getSmoke({
        scale,
        color: this.color,
      }),
      SmokeAction.material,
    );
    this.smokeEntity.meshRendererComponent.isPickable = false;
    this.smokeEntity.meshRendererComponent.castShadows = false;
    this.smokeEntity.meshRendererComponent.receiveShadows = false;
    this.smokeEntity.name = '_ParticleSystemSmoke';
    entity.transformComponent.attachChild(this.smokeEntity.transformComponent);

    this.smokeEntity.addToWorld();
  }

  cleanup() /* fsm */{
    if (this.smokeEntity) {
      this.smokeEntity.removeFromWorld();
      this.smokeEntity = null;
    }
  }
}

SmokeAction.material = null;

SmokeAction.external = {
  key: 'Smoke',
  name: 'Smoke FX',
  type: 'fx',
  description: 'Makes the entity emit smoke. To cancel the smoke emitter use the "Remove Particles" action.',
  parameters: [{
    name: 'Color',
    key: 'color',
    type: 'vec3',
    control: 'color',
    description: 'Smoke color.',
    default: [0, 0, 0],
  }],
  transitions: [],
};

SmokeAction.register();

export default SmokeAction;
